import { Component, OnInit } from '@angular/core';
import { UserService } from '@services/user.service';
import { PageService } from '@services/page.service';
import { HttpUtilService } from '@services/http-util.service';
import { environment } from '@env/environment.prod';
import { NotificationsService } from '@services/notifications.service';
import { TranslationService } from '@services/translation.service';
import { Router } from '@angular/router';
import { MainSidebarService } from '@services/main-sidebar.service';

@Component({
  selector: "app-verify-phone-and-email",
  templateUrl: "./verify-phone-and-email.component.html",
  styleUrls: ["./verify-phone-and-email.component.scss"],
})
export class VerifyPhoneAndEmailComponent implements OnInit {
  viewMode = "VERIFY"; // 'VERIFY' | 'EDIT'

  userInfo;
  verificationCode = {
    email: {
      codeSent: false,
      code: null,
    },
    phone_number: {
      codeSent: false,
      code: null,
    },
  };

  disableSave = false;

  updatedData = {
    data: {
      email: null,
      phone_number: null,
    },
  };

  phoneNumberObj = {
    label: "Phone Number",
    value: null,
    type: "users",
  };
  phoneNumberInfo = {
    type: "users",
  };
  cognitoSsoUr$;
  hasSSOEnabled;

  constructor(
    private router: Router,
    private userService: UserService,
    private page: PageService,
    private notifications: NotificationsService,
    private httpUtils: HttpUtilService,
    private translationService: TranslationService,
    private mainSidebarService:MainSidebarService
  ) {}

  ngOnInit() {
    this.page.updateHideMenu(true);
    this.userInfo = this.userService.getUserInfo();
    this.updatedData.data = {
      email: this.userInfo.email,
      phone_number: this.userInfo.phone_number,
    };
  }

  phoneNumberChanged({ value }) {
    if (value) this.updatedData.data.phone_number = value;
  }

  cancelEdit() {
    this.viewMode = "VERIFY";
    // Reset values
    this.updatedData.data.email = this.userInfo.email;
    this.updatedData.data.phone_number = this.userInfo.phone_number;
  }

  saveNewContact() {
    this.disableSave = true;
    const updates = this.hasSSOEnabled
      ? { data: { phone_number: this.updatedData.data.phone_number } }
      : this.updatedData;
    this.httpUtils
      .request("PUT", environment.apiRoot + "/users/self", updates, null, true)
      .subscribe((data) => {
        if (data?.updated) {
          this.userService.resetUserInfo().subscribe((newInfo) => {
            this.userInfo = newInfo;
            this.disableSave = false;
            this.viewMode = "VERIFY";
            this.notifications.popNotification("", "Updated User");
          });
        } else {
          const message = data.errorMessage
            ? `Error Updating User: ${data.errorMessage}`
            : "Uknown Error Updating User";
          this.notifications.popNotification("", message);
        }
      });
  }

  handleVerificationError(contactType,error='Uknown Error'){
    const text = this.translationService.getTranslatedContent('error_attempting_to_validate','Error attempting to Validate')

    this.verificationCode[contactType].code = null;
    this.notifications.popNotification('',text+": " +error)
}


  requestVerification(contactType) {
    this.userService.getVerificationCode(contactType).subscribe(
      () => {
        this.verificationCode[contactType].codeSent = true;
      },
      (err) => {
        // Unable to send verification at this time
        console.log(err);
        console.log("Unable to send verification at this time");
      }
    );
  }

  sendVerificataion(contactType) {
    this.userService
      .sendVerficationCode(contactType, this.verificationCode[contactType].code)
      .subscribe(
        (data) => {
          if(data?.error)return this.handleVerificationError(contactType,data?.error)          
          this.userInfo[contactType + "_verified"] = true;
          this.userService.setUserInfo(this.userInfo);
          this.verificationCode[contactType].codeSent = false;
          this.verificationCode[contactType].code = null;
          this.userService.getCognitoUserAttributes$(true); //refreshes for all other subscribers of CognitoUserAttributes
        },
        (err) => {
          this.handleVerificationError(contactType,err?.message)
        }
      );
  }

  navHome() {
    this.userService.checkForMfaEnabled()
    this.mainSidebarService.updateState(true)
    this.router.navigate(["/home"]);
  }
}
